import { defineComponent as P, computed as l, useSlots as R, openBlock as a, createElementBlock as d, normalizeClass as y, createElementVNode as x, toDisplayString as u, createCommentVNode as n, createBlock as r, resolveDynamicComponent as A, withCtx as c, createTextVNode as m, renderSlot as S, unref as g, createVNode as $, mergeProps as I } from "vue";
import { RevButton as B } from "@ds/components/Button";
import { RevIllustration as j } from "@ds/components/Illustration";
import { isString as E } from "../../utils/isString.js";
import { isValidNumber as L } from "../../utils/isValidNumber.js";
import { tw as e } from "../../utils/tailwind.js";
const z = {
  key: 0,
  class: "text-static-default-low body-2 mb-2"
}, W = {
  key: 1,
  class: "text-static-default-low body-1"
}, q = {
  key: 2,
  class: "mt-20 hidden md:block"
}, F = { class: "flex flex-wrap gap-12" }, G = {
  key: 1,
  class: "order-2 mt-20 flex flex-col gap-12 md:!hidden"
}, U = /* @__PURE__ */ P({
  name: "RevContentBlock",
  __name: "ContentBlock",
  props: {
    hasRoundedContainer: { type: Boolean, default: !1 },
    buttonDisabled: { type: Boolean, default: !1 },
    buttonLabel: { default: () => {
    } },
    target: { default: "_self" },
    buttonLoading: { type: Boolean, default: !1 },
    hasRoundedImage: { type: Boolean, default: !1 },
    buttonLoadingAlternativeText: {},
    buttonVariant: { default: "primary" },
    imageLeft: { type: Boolean, default: !1 },
    imageProps: {},
    surtitle: {},
    title: {},
    titleTag: { default: "h2" },
    titleVariant: { default: "title1" },
    to: {},
    secondaryButtonDisabled: { type: Boolean, default: !1 },
    secondaryButtonLabel: { default: () => {
    } },
    secondaryButtonTarget: { default: "_self" },
    secondaryButtonLoading: { type: Boolean, default: !1 },
    secondaryButtonLoadingAlternativeText: {},
    secondaryButtonTo: {}
  },
  emits: ["click", "click-secondary-button"],
  setup(t) {
    const k = l(() => [
      e`flex flex-col md:flex-row md:items-center`,
      t.hasRoundedContainer && e`rounded-lg overflow-hidden`
    ]), h = l(() => [
      e`text-static-default-hi mb-8`,
      t.titleVariant === "punchline" && e`punchline`,
      t.titleVariant === "title1" && e`heading-1`,
      t.titleVariant === "title2" && e`heading-2`
    ]), C = l(() => [
      e`w-full`,
      t.hasRoundedImage && e`rounded-lg overflow-hidden`
    ]), w = l(() => [
      e`min-w-[40%] flex-initial items-center justify-center md:mb-0 md:w-448 md:min-w-448`,
      t.imageLeft ? e`mb-16` : e`order-1 md:ml-auto`
    ]), f = l(
      () => E(t.imageProps?.src) && L(t.imageProps?.height) && L(t.imageProps?.width)
    ), T = l(() => [
      e`flex flex-col justify-center md:mb-0`,
      f.value && t.imageLeft && e`order-1 md:ml-56 md:mr-0`,
      f.value && !t.imageLeft && e`mb-16 md:mr-56`,
      !f.value && e`mb-16`
    ]), b = l(() => t.buttonLabel !== void 0), v = l(() => t.secondaryButtonLabel !== void 0), V = l(() => !!t.surtitle), N = R(), D = l(() => !!N);
    return (s, o) => (a(), d("div", {
      class: y(k.value)
    }, [
      x("div", {
        class: y(T.value)
      }, [
        V.value ? (a(), d("p", z, u(t.surtitle), 1)) : n("", !0),
        (a(), r(A(t.titleTag), {
          class: y(h.value)
        }, {
          default: c(() => [
            m(u(t.title), 1)
          ]),
          _: 1
        }, 8, ["class"])),
        D.value ? (a(), d("div", W, [
          S(s.$slots, "default")
        ])) : n("", !0),
        b.value || v.value ? (a(), d("div", q, [
          x("div", F, [
            b.value ? (a(), r(g(B), {
              key: 0,
              disabled: t.buttonDisabled,
              loading: t.buttonLoading,
              "loading-alternative-text": t.buttonLoadingAlternativeText,
              target: t.target,
              to: t.to,
              variant: t.buttonVariant,
              onClick: o[0] || (o[0] = (i) => s.$emit("click", i))
            }, {
              default: c(() => [
                m(u(t.buttonLabel), 1)
              ]),
              _: 1
            }, 8, ["disabled", "loading", "loading-alternative-text", "target", "to", "variant"])) : n("", !0),
            v.value ? (a(), r(g(B), {
              key: 1,
              disabled: t.secondaryButtonDisabled,
              loading: t.secondaryButtonLoading,
              "loading-alternative-text": t.secondaryButtonLoadingAlternativeText,
              target: t.secondaryButtonTarget,
              to: t.secondaryButtonTo,
              variant: "secondary",
              onClick: o[1] || (o[1] = (i) => s.$emit("click-secondary-button", i))
            }, {
              default: c(() => [
                m(u(t.secondaryButtonLabel), 1)
              ]),
              _: 1
            }, 8, ["disabled", "loading", "loading-alternative-text", "target", "to"])) : n("", !0)
          ])
        ])) : n("", !0)
      ], 2),
      f.value ? (a(), d("div", {
        key: 0,
        class: y(w.value)
      }, [
        $(g(j), I(t.imageProps, {
          alt: t.imageProps?.alt ?? "",
          class: C.value
        }), null, 16, ["alt", "class"])
      ], 2)) : n("", !0),
      b.value || v.value ? (a(), d("div", G, [
        b.value ? (a(), r(g(B), {
          key: 0,
          "data-test": "small-screen-button",
          disabled: t.buttonDisabled,
          "full-width": "always",
          loading: t.buttonLoading,
          "loading-alternative-text": t.buttonLoadingAlternativeText,
          target: t.target,
          to: t.to,
          variant: t.buttonVariant,
          onClick: o[2] || (o[2] = (i) => s.$emit("click", i))
        }, {
          default: c(() => [
            m(u(t.buttonLabel), 1)
          ]),
          _: 1
        }, 8, ["disabled", "loading", "loading-alternative-text", "target", "to", "variant"])) : n("", !0),
        v.value ? (a(), r(g(B), {
          key: 1,
          "data-test": "small-screen-secondary-button",
          disabled: t.secondaryButtonDisabled,
          "full-width": "always",
          loading: t.secondaryButtonLoading,
          "loading-alternative-text": t.secondaryButtonLoadingAlternativeText,
          target: t.secondaryButtonTarget,
          to: t.secondaryButtonTo,
          variant: "secondary",
          onClick: o[3] || (o[3] = (i) => s.$emit("click-secondary-button", i))
        }, {
          default: c(() => [
            m(u(t.secondaryButtonLabel), 1)
          ]),
          _: 1
        }, 8, ["disabled", "loading", "loading-alternative-text", "target", "to"])) : n("", !0)
      ])) : n("", !0)
    ], 2));
  }
});
export {
  U as default
};
